import { createAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';

export interface ToggleExpandNote {
    noteId: string;
}

export const toggleExpandNote = createAction<ActionType, ToggleExpandNote>(
    ActionType.COMMITMENT_NARRATIVE__TOGGLE_EXPAND_NOTE,
);
